export default [
    "close_thread",
    "recivers",
    "thread_closed_correctly",
    "open",
    "closed",
    "category",
    "needs_reply",
    "waiting_for_reply",
    "reply",
    "subject",
    "message",
    "new_message",
    "private_message",
    "message_recipient",
    "thread_added_successfully",
    "reply_added_successfully",
    "require_answer",
    "show_message",
    "price_lists_assigned_to_the_customer",
    "add_price_list",
    "price_list_type",
    "country_or_name",
    "currency",
    "status",
    "close",
    "save",
    "price_list_type_standard",
    "price_list_type_special",
    "pending",
    "valid",
    "archival",
    "show",
    "it_will_not_be_possible_to_retrieve_it_later_!",
    "delete",
    "cancel",
    "delete_price_list_from_client",
    "field_country_name_is_required",
    "department_and_client",
    "attendant_department_data",
    "department_symbol",
    "departments_name",
    "country",
    "identification_number_typ",
    "identification_number",
    "address",
    "zip",
    "city",
    "add_another_tenant",
    "client_data",
    "app_user",
    "user_data_form",
    "company_name_or_first_name_and_second_name",
    "identification_number_id",
    "get_data",
    "client_department",
    "department_country",
    "secondary_identification_number_id",
    "remarks",
    "none",
    "other",
    "copy_client_data",
    "successfully_added_price_lists_to_client",
    "successfully_deleted_price_lists_from_client",
    "cant_add_price_list_to_client",
    "instance_being_created_please_wait",
    "go_to_the_list_of_clients",
    "clients_data_have_been_imported",
    "the_contractor_data_could_not_be_imported_or_the_contractor_was_not_found",
    "save_and_redirect_to_client_edit_form",
    "warning_!",
    "the_user_entity_already_uses_cont_sup",
    "do_you_confirm_adding_a_second_user_with_the_same_id_number_?",
    "yes",
    "no",
    "failed_to_perform_actiono",
    "country_or_department_country",
    "notes",
    "add_a_note",
    "show_hidden",
    "note_title",
    "added_date",
    "user",
    "discover",
    "hide",
    "show_note",
    "added_by",
    "create_note",
    "content",
    "starting_date",
    "max_doc_monthly",
    "max_doc_monthly_short",
    "max_users",
    "subscription",
    "ability_to_add_departments",
    "billing_period",
    "billing_method",
    "no_billing",
    "month",
    "quarter",
    "half_year",
    "year",
    "additional_information",
    "own_name_in_the_application",
    "logo",
    "choose_file",
    "change",
    "active",
    "other_data_user_entity",
    "send",
    "client_already_registered",
    "aging_parameters",
    "all_currencies",
    "aging_for_day",
    "set_the_aging_ranges",
    "apply",
    "remember_intervals",
    "add_interval",
    "from",
    "to",
    "ok",
    "documents_outside_designated_ranges_will_not_be_considered",
    "receivables",
    "liabilities",
    "document_type",
    "document_number",
    "contractor_name",
    "date_issued",
    "sale_date",
    "payment_amount",
    "exchange_rate",
    "amount_due_in_base_currency",
    "due_date",
    "number_of_days_late",
    "download_file",
    "own_invoice",
    "own_documents",
    "own_invoice_correction",
    "own_advance_invoice",
    "own_bill_pl",
    "other_foreign",
    "other_income",
    "other_costs_documents",
    "foreign_advance_invoice",
    "foreign_invoice",
    "foreign_invoice_correction",
    "invoice_pl",
    "own_invoice_pl",
    "own_invoice_correction_pl",
    "bill_pl",
    "prepayment_invoice_pl",
    "invoice_margin_pl",
    "advance_invoice_margin_pl",
    "proforma_invoice_pl",
    "correction_invoice_pl",
    "age_range_from_to_days",
    "sum",
    "with_selected",
    "export",
    "help_and_information",
    "edit_aging_ranges",
    "add_operation",
    "allocated",
    "amount",
    "balance_after_operation",
    "balance_after_allocation",
    "by_title",
    "calculated_amount",
    "cannot_delete_operation_in_different_department",
    "connect_with",
    "contractor",
    "contractors_add",
    "costs",
    "costs_and_incomes_directly_from_statement",
    "currency_exchange",
    "date",
    "department",
    "description",
    "document",
    "document_amount",
    "document_balance",
    "document_or_group",
    "document_or_group_proforma",
    "document_payments",
    "ending_balance",
    "for_split",
    "generated_balance_operation",
    "generated_balance",
    "group",
    "incomes",
    "incorrect_payment_refund",
    "interval_from_day",
    "move_down",
    "move_to_others",
    "move_up",
    "no_categories_created",
    "no_documents",
    "not_allocated_payments_from_contractor",
    "operation_group_add_another_payment_source",
    "operation_group_add_bank_account",
    "operation_group_add_card",
    "operation_group_add_cash_register",
    "operation_group_add_credit_card",
    "operation_group_add_safe",
    "operation_group_created_successfully",
    "operation_group_edit_another_payment_source",
    "operation_group_edit_bank_account",
    "operation_group_edit_card",
    "operation_group_edit_cash_register",
    "operation_group_edit_credit_card",
    "operation_group_edit_safe",
    "operation_group_header_another_payment_source",
    "operation_group_operations_another_payment_source",
    "operation_group_operations_bank_account",
    "operation_group_operations_card",
    "operation_group_operations_cash_register",
    "operation_group_operations_credit_card",
    "operation_group_operations_safe",
    "operation_group_show_another_payment_source",
    "operation_group_show_bank_account",
    "operation_group_show_card",
    "operation_group_show_cash_register",
    "operation_group_show_credit_card",
    "operation_group_show_safe",
    "operation_group_updated_successfully",
    "other_operations",
    "others",
    "payments",
    "payments_for_documents",
    "payment_on_behalf",
    "payment_on_behalf_of_another_contractor",
    "payment_source_name",
    "payment_source_name_short",
    "payment_transfer_to_another_department",
    "payment_transferred_to_department",
    "payments_for_contractor_documents",
    "return",
    "save_cash_register",
    "save_operations",
    "save_statement",
    "starting_balance",
    "to_day",
    "transfer_between_sources",
    "unallocated_payments",
    "contract-order-pl",
    "contract-order-pl-margin",
    "contract-order-name",
    "contract-order-date",
    "contract-detailed",
    "buyer-recipient",
    "full_address",
    "contractor_show",
    "contractor_edit",
    "recipient-data-show",
    "additional_information_invisible_in_document",
    "goods_services",
    "unit_price_calculation",
    "contract_description",
    "lp",
    "good_or_service_name",
    "item_quantity",
    "unit_of_mesure",
    "price",
    "item_net_amount",
    "item_vat_rate",
    "item_vat_amount",
    "item_gross_amount",
    "symbol",
    "pkwiu",
    "goods_or_service_description",
    "add_discount",
    "price_before_discount",
    "discount%",
    "attachments",
    "attachment",
    "document_attachment_name",
    "add_attachment",
    "the_selected_contractor_is_to_be_completed_error",
    "the_selected_contractor_or_other_entity_is_to_be_completed_error",
    "warning",
    "roundings",
    "validation.required",
    "cant_save_check_forms_warnings_and_fix_errors",
    "validation.regex",
    "contractor_name",
    "contractor_history",
    "choose_contractor",
    "generate_balance",
    "unallocated_payments",
    "unallocated_documents",
    "documents",
    "payment_date",
    "payment_source",
    "description",
    "currency",
    "amount",
    "for_allocation",
    "source_contractor",
    "document_date",
    "net_amount",
    "gross_amount",
    "due_date",
    "balance_in_default_currency",
    "section_balance_in_default_currency",
    "No",
    "contractor",
    "type",
    "delete_connection",
    "show",
    "edit",
    "other_sources_of_receivables_and_liabilities",
    "country_code",
    "identification_number_id",
    "identification_number",
    "selected",
    "delete",
    "clear_allocation_so_that_the_relation_can_be_created_anew",
    "chosen_document_and_payments_are_already_related",
    "delete_allocation",
    "add_contractor",
    "select_second_contractor",
    "with_selected",
    "failed_to_perform_action",
    "document_deleted_successfully",
    "payment_source_name",
    "rejected",
    "not_confirmed",
    "next",
    "last",
    "out_of",
    "records",
    "all",
    "page",
    "first",
    "prev",
    "download_file",
    "document_marking",
    "show_non_zero_only",
    "show_rejected",
    "operation_deleted_successfully",
    "value",
    "balance",
    "card_name_or_description",
    "source_type",
    "show_rejected_and_cancelled",
    "unconfirmed",
    "document_to_be_filled",
    "document_to_be_split_for_controlling",
    "not_confirmed",
    "cancelled",
    "the_source_cash_register_department_has_been_hidden",
    "no_authorization_for_the_source_cash_register",
    "positions_settled",
    "payment_source",
    "for_allocation",
    "balance_after_settlement",
    "has_left",
    "documents_settled",
    "documents",
    "settlement_date",
    "operation_saved_successfully",
    "goto_contractor_history",
    "No",
    "generate_balance",
    "created_by",
    "payment_date",
    "delete_allocation",
    "gross_amount",
    "type",
    "generating_transfer_lists",
    "contractor_data",
    "iban",
    "payment_name",
    "split_payment",
    "vat_amount",
    "nip",
    "confirmed",
    "rejected",
    "disposition",
    "confirmed_acronym",
    "not_confirmed_acronym",
    "rejected_acronym",
    "disposition_acronym",
    "transfer_list",
    "from_account",
    "of_day",
    "charges_from",
    "whole_list",
    "transfer_ksef_number",
    "charge_bearer",
    "charge_bearer_sha",
    "charge_bearer_our",
    "charge_bearer_ben",
    "description_big",
    "transfer_list_name",
    "combine_transfers",
    "save_lists",
    "id_card",
    "passport",
    "decade",
    "not_assigned_to_any_period",
    "not_assigned_to_any_period_short",
    "day",
    "bank_name2",
    "other_transfer_data",
    "transfers_rest",
    "correct_control_number",
    "no_verification_mechanism_for_chosen_template",
    "form_symbol",
    "form_symbol_short",
    "period_type",
    "period",
    "liability_id",
    "payer_data",
    "payer_identificator",
    "remove_list",
    "add_list",
    "edit_contractor",
    "download_attachment",
    "invoice_number",
    "document_status",
    "chosen_date_is_later_than_due_date_please_confirm",
    "fill_all_required_fields_before_saving_lists",
    "validation_required_from_account",
    "validation_required_of_day",
    "document_to_be_split_on_employees",
    "other_bank_account",
    "fill_nip",
    "unallocated_documents",
    "export",
    "confirmed",
    "chosen_document_and_payments_are_already_related",
    "clear_allocation_so_that_the_relation_can_be_created_anew",
    "archive",
    "tariff",
    "name",
    "valid_from",
    "add_tariff_type",
    "add_tariff",
    "remove_tariff",
    "tariff_type",
    "contract_or_settlement_period",
    "add_department_possibility",
    "specified_amounts_in_price_list",
    "add_new_price_list",
    "name_obj",
    "valid_from_date",
    "free",
    "pre_paid",
    "surcharge",
    "each_next_document",
    "each_next_user",
    "field_is_required",
    "wrong_value",
    "month_description",
    "document_description",
    "value_must_be_greater_than_0",
    "value_must_be_an_integer",
    "delete_tariff?",
    "given_value_is_to_big",
    "field_name_is_required",
    "field_country_is_required",
    "field_currency_is_required",
    "field_mother_is_required",
    "field_tariff_type_is_required",
    "field_price_list_type_is_required",
    "field_billing_period_is_required",
    "field_max_doc_monthly_is_required",
    "field_max_users_is_required",
    "check_min_one_service_in_free",
    "price_list_must_have_min_one_tariff",
    "price_list_with_that_name_already_exists",
    "edit_price_list",
    "preview_price_list",
    "copy_price_list",
    "price_lists_name_max_lenght_error",
    "prolong_session",
    "session_will_be_expired",
    "add_new",
    "alarm_inform_to",
    "alarm_category",
    "alarm_category_required",
    "add_new_payment_type",
    "payment_type_name",
    "add_new_translation",
    "edit_payment_type",
    "help_and_information",
    "connected_document_was_deleted",
    "add",
    "contract_type_adding",
    "contract_type_invoicing_pl_VAT",
    "contract_type_invoicing_pl_margin",
    "contract_type_adding_buy",
    "contract_type_adding_sell",
    "add_another_listing",
    "type_of_contract_order",
    "information_about_the_contract_order",
    "contract_order_type",
    "documents_in_the_contract",
    "contract_settlement",
    "designation",
    "document_nr",
    "correction_document_nr",
    "document_net_amount",
    "document_gross_amount",
    "advance_payment_for_net_settlement",
    "advance_payment_for_gross_settlement",
    "no_documents_in_the_contract",
    "with_chosen",
    "issue_an_invoice",
    "attach_document_to_contract",
    "detach_document_from_contract",
    "select_documents_to_link_to_the_contract",
    "currency",
    "there_are_draft_documents_not_included_in_settlement_of_contract",
    "left_to_be_invoiced",
    "unit_price",
    "remaining_quantity",
    "net_amount_left",
    "gross_amount_left",
    "advances_to_be_cleared",
    "left_to_be_settled_net",
    "left_to_be_settled_gross",
    "margin_amount_included",
    "margin_amount_included_short",
    "margin_vat_rate_id",
    "margin_vat_rate_id_short",
    "item_margin_vat_amount",
    "item_margin_vat_amount_short",
    "value_left",
    "gross_margin_left",
    "left_to_be_settled",
    "total_advances",
    "include_in_income_expenses",
    "revoke_recognition_of_income_expenses",
    "buyer_vat_number_missing",
    "buyer_or_other_entity_vat_number_missing",
    "make_sure_it_is_possible",
    "margin_type",
    'edition_locked_by_user',
    'own_invoice_for_register',
    'add_own_bill_pl_margin_invoice',
    'cash_register_receipt',
    'own_invoice_pl_for_register',
    'transfer_document_to_department',
    'document_was_adopted_by_another_department',
    'document_was_adopted_by_another_department_delete_alert',
    'document_was_adopted_by_another_department_cash_register_alert',
    'document_was_transfer_and_not_accepted',
    'edit_operations',
    'show_operations',
    'global_contractor_updated_to_non_global_generated_balance_alert',
    'save_group_statement',
    'save_cash_raport',
    'item_name',
    "generate_balance",
    "generating_balance_will_move_to_source_contractor",
    "related_document_swal_alert",
    "alert_message_move_documents_to_department_connected_by_contract",
    "connect",
    "preview",
    "edition",
    "contract_or_order",
    "contract_or_order_for_action",
    "cancelled_acronym",
    "own_advance_invoice_pl",
    "buisnes_invoice_pl",
    "complex_documents",
    "complex_payments",
    "complex_controlling",
    "complex_statistics",
    "complex_invoice_pl",
    "complex_milenium_bank",
    "pro_documents",
    "pro_payments",
    "pro_controlling",
    "pro_statistics",
    "pro_invoice_pl",
    "pro_milenium_bank",
    "complex_transfers",
    "pro_transfers",
    "buisnes_invoice_pl_free",
    "business_rates_quotes",
    "cant_add_contractual_period_with_date_in_other_period",
    "cant_edit_operation_in_cash_register_in_other_department",
    "amount_required",
    "complex_stock",
    "complex_stock_pl",
    "pro_stock",
    "pro_stock_pl",
    "issue_invoice_with_stock",
    "alert_stock_item_detailed_on_edit_was_changed",
    "not_active",
    "stock_group_changed_and_exists_stock_items_without_group",
    "turn_off_stock_item_groups_in_edit_mode_alert",
    "price_list_mother",
    "points_exchange",
    "points_exchange_2",
    "field_exchange_points_is_required",
    "field_exchange_points_max",
    "stock_name",
    "stock_country",
    "stock_currency",
    "additional_information_goods_service",
    "unit_value",
    "connect_document_with_proforma_swal_msg",
    "connect_document_with_proforma_swal_title",
    "order_services_pending_order_exists_alert",
    "create_invoice_for_bill",
    "generating_transfers_description_to_long_message",
    "move_to_another_group",
    "move_to_default_list",
    "activate_template",
    "expected_amount",
    "missing_payment",
    "add_goods_services",
    "selecting_document_items_buy",
    "selecting_document_items_sell",
    "date_type_analyze",
    "date_to_analyze",
    "date_from_analyze",
    "include_correction",
    "download",
    "choosing_position",
    "analyze",
    "chart",
    "list_choosen_buy_positions",
    "list_choosen_sell_positions",
    "settings",
    "available_columns",
    "selected_columns",
    "discount",
    "item_margin",
    "contractor_state_id",
    "margin_type_id",
    "printout_remarks",
    "contractor_city",
    "contractor_country",
    "classification",
    "item_unit_of_measure",
    "item_unit_price",
    "vat_rate_id",
    "document_currency",
    "net_in_base_currency",
    "item_vat_refund",
    "item_vat_refund_amount",
    "date_received",
    "price_type",
    "item_vat_rate_value",
    "part_vat_refunded_from_us",
    "way_of_vat_settlement",
    "reset_to_default",
    "filters",
    "filter",
    "filter_reset",
    "analyze_parameters",
    "divide_into_groups_by",
    "divide_into_subgroups_by",
    "group_by_contractor_groups",
    "group_by_item_groups",
    "group_by_months",
    "group_by_currency",
    "define_criterion",
    "fill_criterion",
    "edit_criterion",
    "contractor_group_edit",
    "item_group_edit",
    "delete_allocation_group",
    "unallocated_group",
    "assign_to_group",
    "create_group",
    "group_name",
    "edit_groups_by_currency",
    "currency_by_default_currency",
    "each_currency_separately",
    "analyze_choosen_sell_positions",
    "analyze_choosen_buy_positions",
    "chart_show_analyze_results",
    "rest_contractors",
    "rest_items",
    "criterias_groups_not_defined",
    "expand",
    "collapse",
    "net_and_vat_cost",
    'payment_term_in_days',
    "real_payment_in_days",
    "import_groups",
    "from_buy_analyze",
    "from_sell_analyze",
    "from_stock",
    "chart_params",
    "chart",
    "line_basic",
    "area_basic",
    "column_with_data_labels",
    "column_with_rotated_labels",
    "column_with_data_inside",
    "bar_basic",
    "bar_with_category_name_and_label_inside",
    "simple_pie",
    "monochrome_pie",
    "simple_donut",
    "gradient_donut",
    "semi_donut",
    "radar_basic",
    "line_synchronized",
    "line_many",
    "column_basic",
    "stacked_column",
    "stacked_column_100",
    "bar_grouped",
    "stacked_bar",
    "stacked_bar_100",
    "radar_multi_series",
    "values_x_axis_is",
    "analyze_sell_part",
    "analyze_buy_part",
    "date_item_name",
    "contractor_item_name",
    "order_item_name",
    "currency_item_name",
    "bar_is",
    "slice_is",
    "arms_is",
    "line_is",
    "separate_chart_as",
    "columns_is",
    "parts_of_columns_is",
    "values_y_axis_is",
    "parts_of_bars_is",
    "series_data_is",
    "edit_groups_by_date",
    "division_into_year",
    "division_into_month",
    "area_basic_multi",
    "column_with_data_labels_multi",
    "simple_pie_multi",
    "simple_donut_multi",
    "monochrome_pie_multi",
    "gradient_donut_multi",
    "semi_donut_multi",
    "line_many_multi",
    "column_basic_multi",
    "stacked_column_multi",
    "stacked_column_100_multi",
    "radar_multi_series_multi",
    "net_value_in_base_currency",
    "years",
    "groups_by_contractor_groups",
    "groups_by_item_groups",
    "groups_by_months",
    "groups_by_currency",
    "years_2",
    "net_base_currency_value",
    "and",
    "too_long_group_name",
    "edit_group_name",
    "group_name_unique_error",
    "group_name_length_error",
    "no_upper",
    "save_settings",
    "rest_currencies",
    "analyze_summary_sell_and_buy",
    "sell_documents_count",
    "sell_value_in_base_currency",
    "net",
    "gross",
    "buy_value_in_base_currency",
    "net_and_vat",
    "values",
    "with_include_correction",
    "without_include_correction",
    "24_months",
    "12_months",
    "sell_analyze_from_24_months",
    "document_count",
    "net_value_without_correction",
    "gross_value_without_correction",
    "net_value_after_correction",
    "gross_value_after_correction",
    "buy_analyze_from_24_months",
    "cost_amount_and_vat_without_correction",
    "cost_amount_and_vat_after_correction",
    "buy_documents",
    "sell_documents",
    "group_by_dates",
    "edit_name",
    "all_values_in_base_currency",
    "checked_checkbox",
    "for_allocated_cspoints_provision_type",
    "for_payment_provision_type",
    "commission_calculated_manually_by",
    "text_information_sum_lenght_cant_be_longer_than_5000_chars",
    "dt_var_factor_data",
    "dt_var_ics_second_company",
    "document_variable_description_factor_data",
    "document_variable_description_ics_second_company",
    "contract_source",
    "order",
    "agreement",
    "contract_number",
    "terms_of_delivery",
    "gtin",
    "cn",
    "pkob",
    "excise_tax_amount",
    "gtu",
    "procedure",
    "pro_sb_analyze",
    "complex_sb_analyze",
    "charge_commission_submit_message",
    "charge_commission?",
    "chart_export_SVG",
    "chart_export_PNG",
    "chart_export_CSV",
    "chart_zoom_in",
    "chart_zoom_out",
    "chart_pan",
    "chart_reset",
    "contract_date",
    "terms_of_delivery",
    'gtin',
    'cn',
    'pkob',
    'excise_tax_amount',
    'gtu',
    'procedure',
    "document_number_correction",
    "document_number_after_correction",
    "document_number_before_correction",
    "doc_numer_after",
    "doc_number_before",
    "correction_seller_data",
    "seller_data_before_correction",
    "seller_data_after_correction",
    "seller_data_before",
    "seller_data_after",
    "correction_receiver_data",
    "receiver_data_before_correction",
    "receiver_data_after_correction",
    "receiver_data_before",
    "receiver_data_after",
    "correction_contract_description",
    "corrected_contract_description",
    "after_correction",
    "correction_contract_value",
    "document_value_correction",
    "dt_var_correction_effect",
    "document_variable_description_correction_effect",
    'procedure',
    "confirm_leaving",
    "if_not_saved_info",
    "add_other_entity",
    "other_entity_role",
    "payer",
    "local_gov_issuer",
    "local_gov_receiver",
    "vat_group_member_issuer",
    "vat_group_member_receiver",
    "other_entity",
    "add_other_entity",
    "factor",
    "additional_contractor",
    "invoice_issuer",
    "role_description",
    "participation_%",
    "original_company",
    "email_in_queue_and_cant_cancel",
    "message_no_options",
    "no_positions",
    "price_list_show_create_row_1",
    "price_list_show_create_row_2",
    "price_list_show_create_row_3",
    "validate_delete_card_message_error",
    "adding_new_card_redirect_info",
    "pro_additional_export_import_pl",
    "complex_additional_export_import_pl",
    "vat_payers_list",
    "import_vat_rates_for_selected_country_alert_text",
    "get_data_from_gus",
    "remove_data_alert?",
    "data_not_be_possible_to_retrieve_it_later_!",
    "unlock_contractor_edit_in_document_title",
    "unlock_contractor_edit_in_document_body",
    "save_analyze_as_pattern",
    "store_sell_analyze_as_pattern_modal_header",
    "store_buy_analyze_as_pattern_modal_header",
    "first_info_row_in_store_analyze_pattern",
    "first_item_row_in_store_analyze_pattern",
    "second_item_row_in_store_analyze_pattern",
    "choose_date_to_in_store_analyze_pattern",
    "always_current_date",
    "fill_data_for_saved_pattern",
    "patter_name",
    "sb_analyze_pattern_is_private",
    "sb_analyze_show_params_pattern",
    "fill_contractor_group_showed_analyzed",
    "fill_item_group_showed_analyzed",
    "error_while_sending_alert_text",
    "fill_item_group_showed_analyzed",
    "unlock_recipient_edit_in_document_title",
    "unlock_recipient_edit_in_document_body",
    "unlock_employee_edit_in_document_title",
    "unlock_employee_edit_in_document_body",
    "generate_pdf",
    "error_while_sending_alert_text",
    "contractor_history_hide_foreign_documents",
    "contractor_history_hide_own_documents",
    "document_save_and_remove_import_errors_alert_text",
    "hide_zero_balances",
    "hide_non_zero_balances",
    "not_paid_documents_own_title",
    "not_paid_documents_foreign_title",
    "show_also_timely_documents",
    "not_paid_own_documents",
    "not_paid_foreign_documents",
    "document_date_short",
    "due_date_short",
    "balance_in_default_currency_short",
    "net_in_base_currency_in",
    "account_owner_register_form",
    "identification_number_typ",
    "secondary_id_number_id",
    "free_documents_first_part_price_list_description",
    "free_documents_second_part_price_list_description",
    "register_form_invoice_warning",
    "generate_button",
    "amount_due_in_base_currency_2",
    "read_again_content",
    "read_again_title",
    "reread",
    "sent_file_without_changes",
    "correction_alert_not_completed_ksef_sending",
    "advance_invoice_has_not_complete_ksef_sending_status",
    "ksef_import_not_success_can_be_saved_as_draft",
    "date_issued_invalid_ksef_range",
    "exit",
    "contract_for_matched_jst",
    "contract_for_matched_gv",
    "jst_contract_alert",
    "vat_contract_alert",
    "jst_contract_alert_warning",
    "gv_contract_alert_warning",
    "change_import_ksef_mode_warning",
    "make_correction_not_complete_last_document_or_given_send_to_ksef",
    "advance_invoice_has_not_complete_ksef_sending_status_2",
    "download_again_from_ksef_info_text",
    "ksef_qr_params_not_present_alert",
    "ksef_temporary_issue_message",
    "download_again_from_ksef_info_text_not_possible",
    "validation_required_transfer_list_name",
    "copy",
    "sort_ascending",
    "sort_descending",
    "pin_column",
    "unpin_column",
    // skrocone etykiety kolumn/pol wg specyfikacji "Drobne poprawki po zwiekszeniu powiekszenia"
    "balance_after_operation_short",
    "number_of_days_late_short",
    "payment_due_date_short",
    "split_payment_short",
    "excise_tax_amount_short",
    "goods_or_service_description_short",
    "analyze_max_columns_exceeded",
    "payment_term_in_days_short",
    "maturity_date_short"
];
